module.exports = __webpack_public_path__ + "assets/53e3600928916423671f3388e2d67844.js";